import _Button from "@arco-design/web-react/es/Button";
import _Link from "@arco-design/web-react/es/Link";
import _Message from "@arco-design/web-react/es/Message";
import _useStorage from "@byted/hooks/es/useStorage";
import _useEventBus from "@byted/hooks/es/useEventBus";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect } from 'react';
import useLocale from './useLocale';
import locale from '../locale';
import { GetThemeDetail } from '@src/utils/api/theme';
import { isByteDanceNet } from '@src/utils/isBT';
var STORAGE_KEY = {
  bindTreeNode: 'notify-bind-tree-node'
};
export default function useGlobalNotify(themeId) {
  var t = useLocale(locale).t;
  var trigger = _useEventBus('openEdit').trigger;
  var _a = __read(_useStorage(STORAGE_KEY.bindTreeNode, "" + Date.now()), 2),
    expireTime = _a[0],
    setExpireTime = _a[1];
  useEffect(function () {
    GetThemeDetail({
      themeId: themeId
    }).then(function (res) {
      if (!res.byteTreeNodeId && isByteDanceNet() && res.isMine) {
        if (checkNeedRemind()) {
          var closeMessage_1 = _Message.warning({
            content: /*#__PURE__*/React.createElement("div", {
              style: {
                display: 'inline-flex',
                alignItems: 'center'
              }
            }, t['bytetree.notify.tipbind'], /*#__PURE__*/React.createElement(_Link, {
              onClick: function onClick() {
                trigger();
                closeMessage_1();
              }
            }, t['bytetree.notify.bindnow']), renderNoRemindButton({
              onClick: function onClick() {
                closeMessage_1();
              }
            })),
            closable: true,
            duration: 0
          });
        }
      }
    });
  }, []);
  var checkNeedRemind = function checkNeedRemind() {
    return Date.now() > +expireTime;
  };
  var renderNoRemindButton = function renderNoRemindButton(_a) {
    var _b = _a.expiryDays,
      expiryDays = _b === void 0 ? 1 : _b,
      _onClick = _a.onClick;
    return /*#__PURE__*/React.createElement(_Button, {
      style: {
        marginLeft: 24
      },
      size: "mini",
      onClick: function onClick() {
        setExpireTime("" + (Date.now() + expiryDays * 24 * 3600 * 1000));
        _onClick && _onClick();
      }
    }, t['bytetree.notify.noremind']);
  };
}